module.exports = __webpack_public_path__ + "static/media/PAN.7a553cbe.png";